"use strict";

/*
  During a Task Queue Playlist:
   - Allows queue task to be set to `completed` after completing the interaction
   - Navigates to the next task in the queue

   @param {React element} - Interaction
*/
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _engagementStatus = require("crm_ui/constants/engagementStatus");

var _EngagementsActions = require("crm_data/engagements/EngagementsActions");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _loggers = require("customer-data-tracking/loggers");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _QueuesPlaylistDeps = _interopRequireDefault(require("crm_ui/queues/QueuesPlaylistDeps"));

var _QueryPlaylistDeps = _interopRequireDefault(require("crm_ui/queues/QueryPlaylistDeps"));

var _generalStore = require("general-store");

var _QueuesActions = require("crm_ui/queues/data/QueuesActions");

var _TaskPlaylistRecord = _interopRequireDefault(require("crm_data/queues/TaskPlaylistRecord"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var propTypes = {
  descriptor: _propTypes.default.instanceOf(_InteractionDescriptorRecord.default),
  engagementType: _propTypes.default.oneOf(Object.keys(_EngagementTypes.default)),
  objectType: _ObjectTypesType.default,
  queues: _reactImmutableProptypes.default.map,
  queueData: _propTypes.default.instanceOf(_TaskPlaylistRecord.default),
  queryPlaylist: _propTypes.default.instanceOf(_TaskPlaylistRecord.default)
};

var InteractionWithQueueTask = function InteractionWithQueueTask(Component) {
  var InteractionWithQueueTaskWrapper =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(InteractionWithQueueTaskWrapper, _PureComponent);

    function InteractionWithQueueTaskWrapper(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithQueueTaskWrapper);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithQueueTaskWrapper).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(InteractionWithQueueTaskWrapper, [{
      key: "getPlaylist",
      value: function getPlaylist() {
        var _this$props = this.props,
            queueData = _this$props.queueData,
            queryPlaylist = _this$props.queryPlaylist;

        if (queueData) {
          return queueData;
        }

        return queryPlaylist;
      }
    }, {
      key: "handleCompleteTask",
      value: function handleCompleteTask() {
        var objectType = this.props.objectType;
        var playlist = this.getPlaylist();
        var taskId = playlist.getIn(['activeTask', 'engagement', 'id']);

        if (!taskId) {
          _loggers.CrmLogger.logError(objectType, {
            action: 'taskId does not exist',
            taskId: taskId
          });
        }

        _loggers.CrmLogger.logRecordInteraction(objectType, {
          action: 'Use task queues',
          subAction: 'Clicks send/save and complete task'
        });

        if (playlist.activeQueue) {
          (0, _QueuesActions.removeFromQueue)(playlist.activeQueue, [taskId]);
        }

        (0, _EngagementsActions.updateEngagement)(parseInt(taskId, 10), (0, _immutable.fromJS)({
          metadata: {
            status: _engagementStatus.COMPLETED
          }
        }));
      }
    }, {
      key: "getSaveLabel",
      value: function getSaveLabel() {
        var descriptor = this.props.descriptor;
        var playlist = this.getPlaylist();
        var type = descriptor ? descriptor.type : _EngagementTypes.default.NOTE.toLowerCase();
        var message = "queues.playlist.interaction.saveAndCompleteLabel." + type;

        if (playlist.isActiveTaskComplete()) {
          return null;
        }

        return _react.default.createElement(_FormattedHTMLMessage.default, {
          message: message
        });
      }
    }, {
      key: "render",
      value: function render() {
        var playlist = this.getPlaylist();

        if (!playlist || playlist.isActiveTaskComplete()) {
          return _react.default.createElement(Component, this.props);
        }

        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          saveLabel: this.getSaveLabel(),
          onCompleteSave: this.handleCompleteTask,
          isQueueTask: true
        }));
      }
    }]);
    return InteractionWithQueueTaskWrapper;
  }(_PureComponent2.default);

  InteractionWithQueueTaskWrapper.propTypes = propTypes;
  var deps = {
    queueData: _QueuesPlaylistDeps.default,
    queryPlaylist: _QueryPlaylistDeps.default
  };
  return (0, _generalStore.connect)(deps)(InteractionWithQueueTaskWrapper);
};

var _default = InteractionWithQueueTask;
exports.default = _default;
module.exports = exports.default;